import { Tag } from 'antd';
import { FunctionComponent } from 'react';
import { Order, OrderType } from '../services/orders-service/types';
import StringUtils from '../utils';

/**
 * OrderTypeTag props
 */
interface Props {
  order: Order;
}

/**
 * OrderTypeTag Component
 */
const OrderTypeTag: FunctionComponent<Props> = ({ order }) => (
  <Tag>
    {StringUtils.capitalize(
      (order.orderType || OrderType.online).toLowerCase(),
    )}
  </Tag>
);

export default OrderTypeTag;
